import { BlockProps } from "@/utils/types";
import { BlockWrapper } from "./BlockWrapper";
import { IconFeature, IconFeatureProps } from "../modules/IconFeature";
import { sanitize } from "@/utils/sanitize";

interface FeaturesProps extends BlockProps {
  items: IconFeatureProps[];
}

export const Features = ({
  backgroundColor = "bg-white",
  bottom,
  className,
  colorStarter,
  componentId,
  heading,
  items,
  primaryEnder,
}: FeaturesProps) => {
  const lightMode =
    sanitize(backgroundColor) === "bg-white" ||
    sanitize(backgroundColor) === "pattern" ||
    sanitize(backgroundColor) === "bg-secondary" ||
    sanitize(backgroundColor) === "bg-tertiary";

  const hasWave = sanitize(backgroundColor) === "waves";
  const hasPattern = sanitize(backgroundColor) === "pattern";

  const blockProps = {
    backgroundColor,
    bottom,
    colorStarter,
    componentId,
    heading,
    lightMode,
    primaryEnder,
  };

  return (
    <BlockWrapper
      {...blockProps}
      className={`features${className ? ` ${className}` : ""}`}
    >
      <div
        className={`flex justify-center gap-2 md:gap-14 flex-wrap ${hasWave ? "max-w-[1064px] bg-primary shadow-md rounded-lg py-8 px-4  mx-auto" : hasPattern ? "max-w-[1064px] bg-secondary shadow-md rounded-lg py-8 px-4  mx-auto" : "contained full"}`}
      >
        {items?.map((item, i) => (
          <IconFeature
            lightMode={lightMode}
            key={item._key || item.heading || "featureItem" + i}
            {...item}
          />
        ))}
      </div>
    </BlockWrapper>
  );
};
